/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-14 08:37:14
 *
 *******************************************************/

// Separate
export const SEPARATE = {
  DEFAULT: ',',
  SELECT: '|',
  PRICE: ';',
  NEW_LINE: '\n'
};
